// Landing page and site header copy. Tone: formal and plain — describe what Basboard does,
// no slogans. Support page shares supportLabel / supportIntro.
export const zh = {
  brandLabel: '战篮 · 返回首页',
  brandName: '战篮',
  menu: '导航菜单',
  language: 'Switch to English',
  features: '产品功能',
  library: '战术库',
  support: '用户支持',
  download: '免费下载',

  heroLine1: '每一套战术，',
  heroLine2: '都值得被讲清楚。',
  heroIntro:
    '战篮是为篮球教练设计的电子战术板。从赛前备课到场边讲解，跑位、掩护与传球均可分步骤演示，帮助队员准确理解战术意图。',
  heroDemo: '查看功能演示',
  heroPlatforms: '支持 iPhone、iPad、Android、Mac 与 Windows',
  heroAlt: '窗光照进球馆，一名球员在场上运球',

  statement: [
    [{ text: '白板能标出站位，' }],
    [{ text: '却难以呈现' }, { text: '先后顺序', accent: true }, { text: '。' }],
    [{ text: '战篮让每一步跑位，' }, { text: '依序呈现', accent: true }, { text: '。' }]
  ],

  demoLine1: '分步骤演示，',
  demoLine2: '战术意图一目了然。',
  demoNow: '当前演示：战篮战术库「{name}」。画面由战篮播放器实时渲染，与 App 内效果一致。',
  stepTitle: '第 {n} 步',
  stepCounter: '第 {n} / {total} 步',
  stepFallback: '按步骤演示跑位。',
  playerTitle: '战篮战术播放器',
  playerLoading: '正在载入战篮播放器…',
  playerError: '播放器加载失败，请稍后再试',
  prevStep: '上一步',
  nextStep: '下一步',
  play: '播放',
  pause: '暂停',

  libraryLine1: '经典战术，',
  libraryLine2: '随时取用。',
  libraryText:
    '战篮 App 内置经典战术库，涵盖挡拆、三分球、单打、低位背打等类别，可根据球队人员配置调整为自己的打法。',
  libraryAll: '全部',
  libraryCategories: [
    { tag: '挡拆', label: '挡拆' },
    { tag: '三分球', label: '三分球' },
    { tag: '单打', label: '单打' },
    { tag: '低位背打', label: '低位背打' }
  ],
  tagLabels: {},
  libraryCategoryLabel: '战术分类',
  librarySteps: '{n} 步',
  libraryPreview: '预览',
  libraryPreviewing: '正在预览',
  libraryOpen: '在 App 中打开',
  libraryCtaTitle: '完整战术库仅在战篮 App 中提供。',
  libraryCtaText: '打开后可根据球队特点调整，并保存至个人战术手册。',
  libraryCtaButton: '在 App 中打开战术库',
  wechatOpenHint: '请点击右上角「···」，选择「在浏览器中打开」，再打开战篮 App。',

  momentsLine1: '覆盖训练与比赛',
  momentsLine2: '全流程。',
  moments: [
    { when: '训练前', title: '讲解新战术', text: '在平板上按步骤演示，可随时暂停与回放。' },
    { when: '比赛暂停', title: '调取预设战术', text: '赛前准备的战术保存在手机中，暂停时即可调出播放。' },
    { when: '训练后', title: '分享给队员复盘', text: '导出视频或分享链接，队员无需安装 App 即可观看。' }
  ],

  devicesLine1: '电脑、平板、手机，',
  devicesLine2: '多端同步。',
  devicesText: '在电脑上备课，在平板上讲解，在手机上随时查看。',
  productAlt: '战篮在电脑、平板、手机上的真实界面',
  hotspots: ['标准比例球场', '保存至战术手册', '分步骤播放', '移动端随时查看'],

  downloadTitle: '开始使用{brand}。',
  downloadText: '免费下载，支持 iPhone、iPad、Android、Mac 与 Windows。',
  recommended: '推荐',
  iosNote: 'App Store 下载',
  androidNote: '下载安装包',
  macNote: '适用于 macOS',
  windowsNote: '适用于 Windows 64 位',
  windowsGuideTitle: 'Windows 安装安全提示',
  windowsGuideSummary: '如出现 SmartScreen 蓝色弹窗，请按以下步骤继续安装。',
  windowsGuideStep: '步骤',
  windowsSteps: [
    { title: '点击「更多信息」', text: '蓝色弹窗出现后，先点击「更多信息」。' },
    { title: '选择「仍要运行」', text: '确认安装包来自战篮官网后，点击「仍要运行」。' },
    { title: '完成安装', text: '按安装向导完成后，从桌面或开始菜单打开战篮。' }
  ],
  windowsGuideNote:
    '该提示来自 Windows Defender SmartScreen，表示安装包暂未建立足够信誉，并不代表安装包损坏。请务必从 basboard.com 官方页面下载。',
  windowsConfirm:
    '即将下载 Windows 版战篮安装包。\n\n如果安装时出现 Windows Defender SmartScreen 蓝色提示，请点击「更多信息」，再选择「仍要运行」。\n\n请确认安装包来自 basboard.com 官方页面。是否继续下载？',
  windows32: '抱歉，目前仅支持 Windows 64 位系统。',
  wechatHint: '请点击微信右上角菜单，选择在浏览器中打开后下载。',
  dismiss: '知道了',

  privacy: '隐私政策',
  agreement: '用户协议',
  help: '帮助中心',
  contact: '联系我们',
  company: '温州上场科技有限公司',
  supportLabel: '用户支持',
  supportIntro: '关于战术、订单或使用中的问题，我们在这里。'
}

export const en = {
  brandLabel: 'Basboard · Home',
  brandName: 'Basboard',
  menu: 'Navigation menu',
  language: '切换到中文',
  features: 'Features',
  library: 'Play library',
  support: 'Support',
  download: 'Download',

  heroLine1: 'Every play',
  heroLine2: 'deserves to be understood.',
  heroIntro:
    'Basboard is a digital tactics board built for basketball coaches. From pre-game planning to sideline instruction, cuts, screens and passes play back step by step, so every player understands the intent.',
  heroDemo: 'See it in action',
  heroPlatforms: 'Available on iPhone, iPad, Android, Mac and Windows',
  heroAlt: 'A player dribbling in a gym lit by window light',

  statement: [
    [{ text: 'A whiteboard shows positions.' }],
    [{ text: 'It cannot show ' }, { text: 'sequence', accent: true }, { text: '.' }],
    [{ text: 'Basboard plays every move ' }, { text: 'in order', accent: true }, { text: '.' }]
  ],

  demoLine1: 'Step by step,',
  demoLine2: 'the intent is clear.',
  demoNow:
    'Now playing “{name}” from the Basboard library, rendered live by the Basboard player exactly as it appears in the app.',
  stepTitle: 'Step {n}',
  stepCounter: 'Step {n} of {total}',
  stepFallback: 'Step-by-step movement.',
  playerTitle: 'Basboard tactic player',
  playerLoading: 'Loading the Basboard player…',
  playerError: 'The player could not load. Please try again later.',
  prevStep: 'Previous step',
  nextStep: 'Next step',
  play: 'Play',
  pause: 'Pause',

  libraryLine1: 'Classic plays,',
  libraryLine2: 'ready when you are.',
  libraryText:
    'The Basboard app includes a library of classic plays — pick and roll, three-point sets, isolation and post-ups — that you can adapt to your own roster.',
  libraryAll: 'All',
  libraryCategories: [
    { tag: 'Pick and Pick', label: 'Pick and roll' },
    { tag: 'Three pointers', label: 'Three-pointers' },
    { tag: 'Single', label: 'Isolation' },
    { tag: 'Low back', label: 'Post-up' }
  ],
  // The app's English library uses literal tag names; show standard basketball terms instead.
  tagLabels: {
    'Pick and Pick': 'Pick and roll',
    'Three pointers': 'Three-pointers',
    Single: 'Isolation',
    'Low back': 'Post-up',
    'Medium distance': 'Mid-range',
    'Cut in': 'Cuts',
    'Hand-by-hand pass': 'Handoff'
  },
  libraryCategoryLabel: 'Play categories',
  librarySteps: '{n} steps',
  libraryPreview: 'Preview',
  libraryPreviewing: 'Previewing',
  libraryOpen: 'Open in app',
  libraryCtaTitle: 'The full library is available in the Basboard app.',
  libraryCtaText: 'Adapt any play to your team and save it to your own playbook.',
  libraryCtaButton: 'Open the library in the app',
  wechatOpenHint: 'Tap “···” in the top-right corner, choose “Open in browser”, then open Basboard.',

  momentsLine1: 'From practice',
  momentsLine2: 'to game day.',
  moments: [
    {
      when: 'Before practice',
      title: 'Teach a new play',
      text: 'Walk through it step by step on a tablet, pausing and replaying as needed.'
    },
    {
      when: 'During a timeout',
      title: 'Pull up a prepared play',
      text: 'Plays prepared before the game are on your phone, ready to run.'
    },
    {
      when: 'After practice',
      title: 'Share for review',
      text: 'Export a video or share a link. Players can watch without installing the app.'
    }
  ],

  devicesLine1: 'Desktop, tablet, phone.',
  devicesLine2: 'Always in sync.',
  devicesText: 'Plan on your computer, teach on a tablet, and check plays on your phone.',
  productAlt: 'Basboard on desktop, tablet and phone',
  hotspots: ['True-to-scale court', 'Saved to your playbook', 'Step-by-step playback', 'Always on your phone'],

  downloadTitle: 'Get started with {brand}.',
  downloadText: 'Free to download for iPhone, iPad, Android, Mac and Windows.',
  recommended: 'Recommended',
  iosNote: 'On the App Store',
  androidNote: 'Download the app',
  macNote: 'For macOS',
  windowsNote: 'For Windows 64-bit',
  windowsGuideTitle: 'Installing on Windows',
  windowsGuideSummary: 'If a blue SmartScreen window appears, follow these steps to continue.',
  windowsGuideStep: 'Step',
  windowsSteps: [
    { title: 'Select “More info”', text: 'When the blue window appears, select “More info” first.' },
    { title: 'Choose “Run anyway”', text: 'After confirming the installer came from the Basboard website, choose “Run anyway”.' },
    { title: 'Finish installing', text: 'Complete the installer, then open Basboard from the desktop or Start menu.' }
  ],
  windowsGuideNote:
    'This notice comes from Windows Defender SmartScreen. It means the installer has not yet built enough reputation, not that it is damaged. Always download from the official basboard.com page.',
  windowsConfirm:
    'You are about to download the Basboard installer for Windows.\n\nIf Windows Defender SmartScreen shows a blue notice during installation, select “More info”, then “Run anyway”.\n\nMake sure the installer comes from the official basboard.com page. Continue?',
  windows32: 'Sorry, Basboard currently supports 64-bit Windows only.',
  wechatHint: 'Open the WeChat menu and choose Open in browser to download.',
  dismiss: 'Got it',

  privacy: 'Privacy',
  agreement: 'Terms',
  help: 'Help center',
  contact: 'Contact',
  company: 'Wenzhou Shangchang Technology',
  supportLabel: 'Support',
  supportIntro: 'For questions about your plays, orders, or using Basboard.'
}
